import { Link } from '@inertiajs/react'

export function SectionHeader({
  title,
  sketch = false,
  viewAll,
}: {
  title: string
  sketch?: boolean
  viewAll?: { label: string; href: string }
}) {
  return (
    <div className="mb-1.5 flex items-center justify-between">
      <h2 className="font-display text-2xl text-ink">
        {sketch ? <span className="sketch">{title}</span> : title}
      </h2>
      {viewAll && (
        <Link href={viewAll.href} className="text-sm font-semibold text-ink-soft hover:text-ink">
          {viewAll.label} →
        </Link>
      )}
    </div>
  )
}
